var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoneImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6597 14.6346C12.0948 12.7972 9.6229 10.1909 8.88332 9.43994L5.8375 10.6426L5.77699 10.6104C5.06986 12.6502 5.19856 16.1866 5.19856 16.1866C5.20772 16.1974 5.21624 16.2085 5.22519 16.2194C8.17528 16.2764 12.1735 14.8084 12.6597 14.6346Z",
    fill: "#FD6050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.97 13.271C14.5845 11.428 14.8021 9.11661 14.9188 8.37273L11.2328 6.01367L8.89268 8.01776V9.43616L8.88336 9.43981C9.62295 10.1908 12.0948 12.7971 12.6597 14.6345C14.0755 14.1767 15.4691 13.502 15.97 13.271Z",
    fill: "#FD8F01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.80407 10.6194L2.91178 9.08398C2.91178 9.08398 -0.000404954 10.7406 0.651619 15.026C0.651619 15.026 2.11497 14.9809 2.96637 15.089C3.81777 15.1971 4.6707 15.5408 5.22563 16.1955C5.22563 16.1955 5.09693 12.6592 5.80407 10.6194Z",
    fill: "#D63B78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.97 13.2711C18.4288 12.1371 21.4204 10.5275 22.9928 9.14685C22.7452 8.69732 22.5459 8.13535 22.4607 7.43457L14.9222 8.37496L14.9188 8.37279C14.8021 9.11667 14.5845 11.4281 15.97 13.2711Z",
    fill: "#FDCB50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M22.9928 9.14697C21.4204 10.5276 18.4287 12.1371 15.9699 13.2712C15.5002 13.4882 15.027 13.6975 14.5505 13.899C15.0264 14.2247 16.8944 15.5917 17.0909 17.1032C18.0055 17.027 19.0027 17.0049 20.0539 17.0492C20.7818 15.0332 24.0606 11.5555 24.7993 10.7882C24.7886 10.7847 23.695 10.4215 22.9928 9.14697Z",
    fill: "#67CCD1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M26.4706 13.7233C26.4706 13.7233 24.9522 12.9391 24.8 10.7883L24.7993 10.7881C24.0606 11.5554 20.7818 15.0331 20.054 17.0491C21.3954 17.1056 22.8249 17.2702 24.2834 17.5688C24.2833 17.5687 25.8144 15.9657 26.4706 13.7233Z",
    fill: "#1A8DC2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M14.5505 13.8989L14.5016 13.9196C13.9289 14.1602 11.6703 14.9768 11.1564 15.1347C11.1377 15.584 11.0827 17.7375 11.6745 18.8263C12.1168 18.4952 12.6159 18.1861 13.1599 17.9515C14.1044 17.5444 15.4678 17.2386 17.091 17.1033C16.8945 15.5916 15.0264 14.2246 14.5505 13.8989Z",
    fill: "#91B706"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M11.1564 15.1348C9.21292 15.7319 7.11788 16.1805 5.22528 16.2195C5.99674 17.1594 6.04804 18.519 6.71203 19.5415C7.31773 20.4744 8.44262 21.0444 9.55301 20.9813C9.55301 20.9813 10.3642 19.8072 11.6746 18.8262C11.0827 17.7376 11.1378 15.5841 11.1564 15.1348Z",
    fill: "#B1D952"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoneImage);
export default __webpack_public_path__ + "static/media/zone_image.9775fa4a982fa78cb99bcbf0ca1c8762.svg";
export { ForwardRef as ReactComponent };